import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  addButton: {
    marginBlock: 24
  },
  wrapper: {
    marginBottom: 24
  }
}))
